export const updateRoutesMapping = (builder) => ({
    updateRoutesMapping: builder.mutation({
        query: (data) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: '/assign_route_to_enterpriseuser',
                method: 'POST',
                body: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
        }
    })
});
